export default angular
  .module('app')
  .directive('holdingButtonDisabled', holdingButtonDisabled)
  .name;

function holdingButtonDisabled() {
  'ngInject';

  return {
    link,
    restrict: 'A',
    scope: {
      holdingButtonDisabled: '='
    },
  };

  function link(scope, element) {
    function onAttributeChange(needDisabled) {
      if (needDisabled) {
        element.addClass('disabled');
        element.prop('disabled', true);
      } else {
        element.removeClass('disabled');
        element.prop('disabled', false);
      }

      element.prop('disabled', needDisabled);
    }

    scope.$watch('holdingButtonDisabled', onAttributeChange);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/directives/button-disabled.js